import { useContext } from 'react';
import { PlatformContext, PlatformContextType } from './PlatformContext';

export function usePlatform(): PlatformContextType {
  const context = useContext(PlatformContext);
  if (context === undefined) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }
  return context;
}
